"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyDay = void 0;
var react_1 = __importStar(require("react"));
var InputSelectMoment_styles_1 = __importDefault(require("./InputSelectMoment.styles"));
var InputSelect_1 = __importDefault(require("../InputSelect/InputSelect"));
var InputTime_1 = __importDefault(require("../InputTime/InputTime"));
var FormErrorMessage_1 = __importDefault(require("../FormErrorMessage/FormErrorMessage"));
exports.emptyDay = { day: 'Maandag', start: '09:00', end: '10:00' };
var InputSelectMoment = function (_a) {
    var id = _a.id, dayValues = _a.dayValues, _b = _a.value, value = _b === void 0 ? [exports.emptyDay] : _b, error = _a.error, valueChanged = _a.valueChanged;
    var _c = react_1.useState(value), days = _c[0], setDays = _c[1];
    var addDay = function (e) {
        e.preventDefault();
        setDays(function (prevDays) { return __spreadArrays(prevDays, [__assign({}, exports.emptyDay)]); });
    };
    var updateDay = function (dayId, newValue) {
        setDays(function (prevDays) {
            var newDays = __spreadArrays(prevDays);
            newDays[dayId] = __assign(__assign({}, prevDays[dayId]), { day: newValue });
            return newDays;
        });
    };
    var updateEndTime = function (dayId, newValue) {
        setDays(function (prevDays) {
            var newDays = __spreadArrays(prevDays);
            newDays[dayId] = __assign(__assign({}, prevDays[dayId]), { end: newValue });
            return newDays;
        });
    };
    var updateStartTime = function (dayId, newValue) {
        setDays(function (prevDays) {
            var newDays = __spreadArrays(prevDays);
            newDays[dayId] = __assign(__assign({}, prevDays[dayId]), { start: newValue });
            return newDays;
        });
    };
    var removeDay = function (index) {
        setDays(function (prevDays) {
            var newDays = __spreadArrays(prevDays);
            newDays.splice(index, 1);
            return newDays;
        });
    };
    react_1.useEffect(function () {
        valueChanged(id, days);
    }, [days]);
    react_1.useEffect(function () {
        setDays(value);
    }, [value]);
    return (react_1.default.createElement(InputSelectMoment_styles_1.default, null,
        react_1.default.createElement("div", { className: "labels" },
            react_1.default.createElement("p", { className: "label label--day" }, "Kies dag"),
            react_1.default.createElement("p", { className: "label label--time" }, "Begintijd"),
            react_1.default.createElement("p", { className: "label label--time" }, "Eindtijd")),
        react_1.default.createElement("div", { className: "days" }, days.map(function (_a, index) {
            var day = _a.day, start = _a.start, end = _a.end;
            return (react_1.default.createElement("div", { key: index, className: "day" },
                react_1.default.createElement(InputSelect_1.default, { placeholder: dayValues.placeholder, options: dayValues.options, required: true, value: day, id: index.toString(), valueChanged: updateDay }),
                react_1.default.createElement(InputTime_1.default, { name: index + "_start", value: start, valueChanged: function (newValue) {
                        updateStartTime("" + index, newValue);
                    } }),
                react_1.default.createElement(InputTime_1.default, { name: index + "_end", value: end, valueChanged: function (newValue) {
                        updateEndTime("" + index, newValue);
                    } }),
                days.length > 1 && (react_1.default.createElement("button", { type: "button", onClick: function () { return removeDay(index); }, className: "remove-day" },
                    react_1.default.createElement("svg", { className: "icon icon-min", "aria-hidden": "true" },
                        react_1.default.createElement("use", { xmlnsXlink: "http://www.w3.org/1999/xlink", xlinkHref: "/dist/svg/sprite.min.svg#cross" }))))));
        })),
        react_1.default.createElement("button", { type: "button", onClick: addDay, className: "add-day" },
            "Voeg dag toe",
            react_1.default.createElement("svg", { className: "icon icon-arrow", "aria-hidden": "true" },
                react_1.default.createElement("use", { xmlnsXlink: "http://www.w3.org/1999/xlink", xlinkHref: "/dist/svg/sprite.min.svg#plus" }))),
        react_1.default.createElement(FormErrorMessage_1.default, null, error)));
};
exports.default = InputSelectMoment;
